import { render } from "./libraries.vue?vue&type=template&id=2028fada"
import script from "./libraries.vue?vue&type=script&lang=js"
export * from "./libraries.vue?vue&type=script&lang=js"

import "./libraries.vue?vue&type=style&index=0&id=2028fada&lang=css"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__